import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Tool-call / tool-error breakdowns for the merchant-support dashboard,
 * loaded lazily (separately from getAskRedoThreads) because they require
 * scanning sub-agent child-thread messages. Input mirrors the thread filters.
 */
export const getAskRedoToolMetrics = {
  name: "getAskRedoToolMetrics" as const,

  input: z.object({
    agentNames: z.array(z.string()),
    searchQuery: z.string().optional(),
    calledAgentFilter: z.string().optional(),
    escalationFilter: createEnum(["yes", "no"]).optional(),
    channelTypeFilter: createEnum([
      "general",
      "support",
      "ask-redo",
    ]).optional(),
    sourceFilter: createEnum([
      "slack",
      "ai-draft",
      "ai-draft-slack",
      "ai-draft-intercom",
      "email",
    ]).optional(),
    dateRange: z
      .object({ start: z.date().nullable(), end: z.date().nullable() })
      .optional(),
    internal: z.boolean().optional(),
    skipEmailFilter: z.boolean().optional(),
    teamIdFilter: z.string().optional(),
    attemptedIntercomConversationIds: z.array(z.string()).optional(),
    excludeThreadSources: z.array(z.string()).optional(),
    toolFilter: z.string().optional(),
    subcategoryFilter: z.array(z.string()).optional(),
  }),

  output: z.object({
    toolCallCounts: z.record(z.string(), z.number()),
    toolCallErrors: z.record(z.string(), z.number()),
  }),
};
